/** Delete in two clicks: the first arms it, the second deletes. No modal for a row action. */

import { useEffect, useRef, useState } from "react";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export function DeleteButton({
  what,
  pending,
  onDelete,
  verb = "Delete",
  disabledReason,
}: {
  what: string;
  pending: boolean;
  onDelete: () => void;
  /** "Remove" for taking someone out of a list rather than deleting a record. */
  verb?: string;
  /** Shown as the tooltip of a disabled button, e.g. why the last owner stays. */
  disabledReason?: string | null | undefined;
}) {
  const [armed, setArmed] = useState(false);
  const box = useRef<HTMLSpanElement>(null);
  const wasArmed = useRef(false);
  // Keyboard users land on the confirm button when armed, and back on the bin after "Keep".
  useEffect(() => {
    if (armed || wasArmed.current) box.current?.querySelector("button")?.focus();
    wasArmed.current = armed;
  }, [armed]);
  if (armed) {
    return (
      <span ref={box} className="flex items-center gap-1.5">
        <Button size="sm" variant="primary" disabled={pending} onClick={onDelete}>
          {verb} {what}
        </Button>
        <Button size="sm" variant="ghost" onClick={() => setArmed(false)}>
          Keep
        </Button>
      </span>
    );
  }
  return (
    <span ref={box} className="contents">
      <Button
        size="sm"
        variant="ghost"
        icon
        aria-label={`${verb} ${what}`}
        title={disabledReason ?? `${verb} ${what}`}
        disabled={!!disabledReason}
        onClick={() => setArmed(true)}
      >
        <Trash2 size={14} strokeWidth={1.8} aria-hidden />
      </Button>
    </span>
  );
}
